import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {loadLoadingState} from '../../../shared/utils/loadingStateLocalStorage';
import {Platform} from 'react-native';

export type LoaderTextState = string;

const initialStateSetter = () => {
  const isStateSavedLocalStorage = Platform.OS === 'web' ? loadLoadingState() : false;
  if (isStateSavedLocalStorage) {
    return isStateSavedLocalStorage.text;
  }
  return '';
};

const initialState: LoaderTextState = initialStateSetter() as unknown as LoaderTextState;

export const loaderTextSlice = createSlice({
  name: '@@eskso/loader/loaderText',
  initialState,
  reducers: {
    reset: () => initialState,
    setText: (state, action: PayloadAction<string>) => (state = action.payload),
  },
});
